var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinWinnerTrophy3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 35,
    viewBox: "0 0 46 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3149 7.22835C40.3791 4.96446 41.1434 11.4677 39.5211 14.1282C37.9638 16.6949 33.0034 16.493 30.9919 16.94C28.9876 17.3798 30.2998 19.9898 30.2998 19.9898L42.5925 16.0316L44.0345 7.79793L39.6293 5.83685C39.6293 5.83685 37.9278 6.19013 37.3149 7.22835Z",
    fill: "url(#paint0_linear_2390_49759)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41136 7.22835C5.34718 4.96446 4.58293 11.4677 6.19794 14.1282C7.75526 16.6949 12.7156 16.493 14.7272 16.94C16.7315 17.3798 15.4193 19.9898 15.4193 19.9898L3.12654 16.0316L1.68457 7.79793L6.08979 5.83685C6.08979 5.83685 7.79131 6.19013 8.40415 7.22835H8.41136Z",
    fill: "url(#paint1_linear_2390_49759)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.683 6.90386C34.683 6.90386 36.8964 5.1014 42.1235 5.23117C47.3435 5.36095 44.7119 14.1498 42.6499 17.0337C40.6672 19.8023 33.7529 18.5838 32.4768 19.3048C31.2078 20.0186 32.2821 21.684 31.763 21.9724C31.2439 22.2608 29.6289 20.5593 30.011 19.1029C30.4076 17.6177 37.6895 16.7741 40.285 14.4021C42.9743 11.9435 42.1236 7.09131 39.7515 6.77408C36.9902 6.40638 36.6729 7.84835 36.4999 9.48498C36.3268 11.0856 33.6952 11.4965 33.6952 11.4965L34.6902 6.89666L34.683 6.90386Z",
    fill: "url(#paint2_linear_2390_49759)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1933 21.9942C14.1068 22.0086 14.0419 22.0086 14.0203 22.0086C14.0203 22.0086 13.9554 21.9942 13.9266 21.9797C13.4003 21.6841 14.4817 20.0259 13.2128 19.3121C11.9367 18.5911 5.02242 19.8096 3.03971 17.041C0.970488 14.1571 -1.65389 5.36827 3.56604 5.23849C8.79317 5.10872 11.0138 6.90396 11.0138 6.90396L12.0088 11.5111C12.0088 11.5111 9.36996 11.1001 9.20414 9.49951C9.0311 7.86288 8.71386 6.4209 5.95249 6.7886C3.57325 7.10584 2.72249 11.9509 5.41897 14.4094C8.01451 16.7814 15.2964 17.625 15.693 19.1102C15.7074 19.1751 15.7218 19.24 15.7362 19.3049C15.9093 20.5089 14.8422 21.8139 14.215 21.9942H14.1933Z",
    fill: "url(#paint3_linear_2390_49759)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8648 19.8096C31.2159 18.8074 35.9744 16.6157 38.6709 16.2263C41.3818 15.837 42.1532 17.0338 42.1316 17.3222C42.11 17.6106 41.1799 18.6128 37.885 18.9084C34.6045 19.204 32.903 18.7209 31.8648 19.8096Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76495 18.5983C2.40516 17.1058 9.06705 16.7598 11.8861 17.5168C14.6691 18.2666 14.4384 19.9393 14.114 19.9898C13.7895 20.033 13.977 19.2616 12.7945 19.1751C11.6049 19.0813 6.98342 19.002 5.77216 18.6055L5.76495 18.5983Z",
    fill: "#FF4D74"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74902 5.83687C4.09222 3.81812 10.5955 4.63283 10.5955 4.63283L10.9992 6.90393C10.9992 6.90393 4.40224 4.18582 1.74902 5.83687Z",
    fill: "url(#paint4_linear_2390_49759)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9321 4.01277C35.9321 4.01277 42.1397 3.80368 43.5312 5.5773C43.5312 5.5773 40.9213 4.2579 35.0957 6.63715L35.9321 4.01997V4.01277Z",
    fill: "url(#paint5_linear_2390_49759)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9311 4.4166C35.9311 4.4166 34.5972 10.0619 33.2418 14.0489C33.2274 14.0922 33.2058 14.1427 33.1914 14.2003C33.1769 14.2364 33.1625 14.2652 33.1553 14.3085C32.6938 15.6423 32.2324 16.767 31.8287 17.3943C30.2569 19.8168 24.4026 22.3691 23.6816 26.8608C23.5013 27.9639 23.732 28.8075 24.1791 29.4564C25.4264 31.2877 28.368 31.6121 28.8438 31.9365C28.8582 31.951 28.8726 31.9582 28.8871 31.9726C29.4999 32.4557 30.0767 33.9193 30.0767 33.9193C30.0767 33.9193 26.8611 34.4095 22.7947 34.4095C18.7284 34.4095 15.5561 33.9193 15.5561 33.9193C15.5561 33.9193 16.1617 32.3836 16.789 31.9365C17.2648 31.6049 20.3794 31.2732 21.6267 29.3698C22.0521 28.7282 22.2612 27.9135 22.0954 26.8536C21.3816 22.3619 15.3686 19.8024 13.7969 17.3871C12.8812 15.9812 11.9944 12.1672 11.3816 9.07414C10.8985 6.63722 10.5957 4.6473 10.5957 4.6473L22.8885 6.60838L35.9239 4.4166H35.9311Z",
    fill: "url(#paint6_linear_2390_49759)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9117 3.4937C13.7596 0.335787 28.1432 -1.58204 34.87 2.82318C42.4764 7.79796 6.49927 8.38918 10.9117 3.4937Z",
    fill: "url(#paint7_linear_2390_49759)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.302 3.93346C16.8254 6.11804 30.0411 6.11803 32.651 3.90461C34.4246 2.40497 28.801 1.11441 23.2133 1.17209C17.8564 1.22256 12.7158 2.55638 14.302 3.93346Z",
    fill: "url(#paint8_linear_2390_49759)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1545 14.3011C32.6931 15.6349 32.2317 16.7597 31.8279 17.3869C30.2562 19.8094 24.4018 22.3617 23.6808 26.8534C23.5006 27.9565 23.7313 28.8001 24.1783 29.449C22.8661 30.8261 22.2028 30.4295 21.626 29.3625C22.0514 28.7208 22.2605 27.9061 22.0947 26.8462C21.3809 22.3545 15.3679 19.795 13.7961 17.3797C12.8805 15.9738 11.9937 12.1598 11.3809 9.06677L11.4385 8.92978C11.4385 8.92978 12.4767 17.9204 19.5496 19.9897C26.5431 22.0373 32.0442 17.3292 33.1473 14.2939L33.1545 14.3011Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9668 18.8867C16.2552 18.2595 19.4636 20.8478 22.2682 21.677C25.0728 22.5061 22.8089 24.4167 21.7707 24.1211C20.7325 23.8255 16.558 19.5068 15.974 18.8867H15.9668Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0773 33.912C30.0773 33.912 26.8617 34.4022 22.7953 34.4022C18.729 34.4022 15.5566 33.912 15.5566 33.912C15.5566 33.912 16.1623 32.3763 16.7895 31.9293C16.4723 33.2919 27.0635 32.2465 28.8948 31.9653C29.5077 32.4484 30.0844 33.912 30.0844 33.912H30.0773Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3221 34.3806C22.4836 34.0562 22.2241 33.0901 23.2623 32.5854C23.8895 32.2826 25.2089 32.3403 26.312 32.261C29.2392 32.0519 29.6862 33.7462 29.6214 33.8687C29.5565 33.9913 25.8578 34.3662 24.3221 34.3879V34.3806Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5134 32.607C19.326 32.607 19.1673 33.9696 19.3764 34.1355C19.5855 34.3013 21.5249 34.359 21.8494 34.3806C22.1738 34.4022 22.5199 32.9242 22.8155 32.7151C23.1111 32.506 19.5134 32.607 19.5134 32.607Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9661 32.4917C17.8774 32.4484 19.5284 30.9776 21.9293 30.9776C24.3302 30.9776 25.2891 31.6842 25.354 31.9221C25.4117 32.16 21.8284 32.6071 18.9733 32.4845L18.9661 32.4917Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6213 5.83702C11.9003 5.57747 12.3257 18.0577 19.55 19.9899C26.7742 21.9222 32.6358 10.4081 33.1477 8.06486C33.6596 5.72166 24.9141 7.82693 19.2688 6.93291C13.6235 6.0461 12.6141 5.8298 12.6141 5.8298L12.6213 5.83702Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1804 1.69846C23.7824 2.07337 24.4818 4.8059 25.1235 5.3178C25.7651 5.8297 31.569 4.67612 32.427 3.50812C33.285 2.34013 28.1804 1.69846 28.1804 1.69846Z",
    fill: "#FF450C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1798 1.69846C26.4061 2.05174 28.533 3.61628 29.4054 3.57302C30.2778 3.52255 31.2079 2.30409 30.5518 2.15268C29.8957 2.00127 28.1798 1.70566 28.1798 1.70566V1.69846Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8101 5.5701C39.4856 5.88733 41.7423 6.85345 42.3335 9.91763C42.9247 12.9818 45.0155 10.3214 44.9146 8.06471C44.8064 5.80803 42.0956 5.09425 39.8101 5.5701Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.985374 10.0259C1.10794 12.0374 2.55712 12.9747 2.83831 12.917C3.11949 12.8593 2.59317 7.89174 6.06111 6.21185C7.53912 5.49807 2.0236 5.69995 1.5117 6.21185C0.999801 6.72375 0.870016 8.07199 0.985374 10.0259Z",
    fill: "#FF4D74"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7987 7.37981C13.5658 7.97102 14.9573 9.75906 15.5485 9.6437C16.1397 9.52834 16.0316 6.7886 14.7987 7.37981Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1816 5.69266C12.1816 5.69266 23.912 7.37255 31.8068 6.16851C31.8068 6.16851 20.7613 8.0719 12.1816 5.69266Z",
    fill: "#FFE861"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0684 11.1866C33.0468 11.302 33.0036 11.4245 32.9531 11.5471C32.47 12.5925 30.7901 13.7605 29.8673 13.2703C29.55 13.1044 29.377 12.8521 29.3121 12.5421C29.0814 11.4678 30.1196 9.72302 30.7613 8.69922C31.5904 7.37261 33.2703 10.0691 33.0684 11.1866Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7418 14.4094C28.6985 14.7267 28.6048 15.116 28.4678 15.563C28.1578 16.5652 27.1628 15.837 26.8889 15.0439C26.8384 14.9069 26.8096 14.7771 26.8096 14.6474C26.8096 13.7605 27.7036 12.9819 28.4678 13.3784C28.7274 13.5154 28.8067 13.8759 28.7418 14.4094Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0684 11.1866C33.0468 11.302 33.0036 11.4245 32.9531 11.5471L32.881 11.5615C32.881 11.5615 32.9459 11.2443 32.6503 10.3431C32.3547 9.44184 31.576 8.40362 30.718 9.16786C29.8745 9.9321 29.3338 12.4627 29.3121 12.5421C29.0814 11.4678 30.1196 9.72302 30.7613 8.69922C31.5904 7.37261 33.2703 10.0691 33.0684 11.1866Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7418 14.4094C28.7418 14.4094 28.1146 13.2775 27.5017 13.5298C26.8889 13.7894 26.8889 15.0439 26.8889 15.0439C26.8384 14.9069 26.8096 14.7771 26.8096 14.6474C26.8096 13.7606 27.7036 12.9819 28.4678 13.3784C28.7274 13.5154 28.8067 13.8759 28.7418 14.4094Z",
    fill: "#E56D8D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0645 11.4244C34.0645 11.4244 35.4992 10.7179 36.2274 9.51382C36.9556 8.30977 35.7299 5.23117 35.7299 5.23117L34.0645 11.4316V11.4244Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7398 5.43309C10.7398 5.43309 10.5379 6.50014 10.2928 6.63713C10.0476 6.77412 9.09593 8.80008 9.57178 9.96087C10.0476 11.1217 12.0015 11.5038 12.0015 11.5038C12.0015 11.5038 11.0282 7.98537 10.7398 5.42587V5.43309Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75293 9.96085C3.96202 12.0373 4.61089 12.3473 5.05069 12.1887C5.49049 12.0373 4.83439 7.66812 7.00455 6.73805C7.00455 6.73805 3.84666 6.52176 3.75293 9.96085Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3125 6.87512C39.3702 7.13467 41.0284 9.2832 41.0212 11.4245C41.0068 13.5731 42.4271 9.23993 41.2736 7.85565C40.12 6.47136 39.3197 6.87512 39.3197 6.87512H39.3125Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20163 14.6618C4.14179 14.4455 5.86494 17.0482 7.97021 17.1348C10.0683 17.2213 10.7244 17.1348 10.7244 17.1348C10.7244 17.1348 5.82168 14.7844 5.20163 14.6618Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4564 16.3921C36.4564 16.3921 40.1334 16.3489 40.9914 15.9091C41.8494 15.4765 41.9431 13.7245 41.7196 13.6235C41.5033 13.5154 40.6381 14.5103 38.9727 15.3178C37.3072 16.1253 36.4492 16.3921 36.4492 16.3921H36.4564Z",
    fill: "#FF450C"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5615 5.83705C36.9847 5.98124 37.1433 4.83488 38.8449 4.65463C40.2436 4.51044 40.7843 5.24583 40.7843 5.24583C40.7843 5.24583 40.0633 5.217 37.5615 5.83705Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95208 5.46914C5.22388 5.0005 10.5952 5.17354 8.99463 6.20455C8.99463 6.20455 7.61755 5.69264 5.95208 5.46914Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5141 32.607C18.5696 32.5133 20.2423 31.4535 21.4175 31.9293C22.5999 32.4052 21.6626 32.8161 19.5141 32.607Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7114 15.9091C37.5816 16.0893 39.0235 16.0388 39.3696 15.3827C39.7157 14.7266 37.9781 15.5269 37.7114 15.9091Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57181 16.5147C9.61506 16.7742 7.50979 16.3561 7.5891 15.9163C7.66841 15.4765 9.52134 16.183 9.57181 16.5147Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0115 19.1101C31.403 17.9277 31.1867 21.8426 31.1867 21.8426C31.1867 21.8426 29.5645 20.4511 30.0115 19.1101Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1926 21.9941C14.1061 22.0086 14.0412 22.0086 14.0196 22.0086C13.9403 21.5688 14.8271 18.8723 15.7211 19.3049C15.8941 20.5089 14.8271 21.8139 14.1998 21.9941H14.1926Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 3.45768C14.1127 2.70786 17.9555 1.26589 20.2915 1.69848C22.6275 2.13107 24.8193 4.92128 24.6462 5.23852C24.4732 5.55575 15.2013 5.77925 14.0117 3.45768Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3539 22.7584C24.4743 22.8088 23.364 21.7922 24.0489 21.1938C25.1953 20.1989 29.0454 19.24 30.3864 17.9782L32.5349 15.9595C32.5349 15.9595 32.0374 17.4375 30.2782 18.9443C28.519 20.444 25.7937 22.7439 25.3539 22.7656V22.7584Z",
    fill: "#DE5155"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5843 13.6955C28.6925 16.8102 26.2844 19.4346 23.2058 19.4346C20.1272 19.4346 17.7119 16.8102 17.8272 13.6955C17.9354 10.7035 20.3435 8.36026 23.2058 8.36026C26.0681 8.36026 28.4834 10.7035 28.5843 13.6955Z",
    fill: "url(#paint9_linear_2390_49759)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2809 15.6567C18.7784 13.6668 27.906 12.2897 28.3819 12.8016C28.8649 13.3207 27.8123 18.9012 23.371 18.9588C18.9298 19.0093 18.1439 16.2047 18.2809 15.6639V15.6567Z",
    fill: "white"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8545 11.7061C24.1245 11.8466 24.3243 12.0178 24.4538 12.2198C24.5855 12.4217 24.6513 12.6599 24.6513 12.9343C24.6513 13.3755 24.4889 13.7443 24.164 14.0407C23.8391 14.337 23.4308 14.4852 22.9391 14.4852C22.7415 14.4852 22.5516 14.4534 22.3694 14.3897C22.1894 14.3283 22.0193 14.2361 21.8591 14.1131C21.6725 13.9704 21.5254 13.8135 21.4178 13.6423C21.3125 13.471 21.2598 13.3097 21.2598 13.1582C21.2598 13.0046 21.3059 12.8794 21.3981 12.7828C21.4903 12.6863 21.6088 12.638 21.7537 12.638C21.8459 12.638 21.9271 12.6599 21.9974 12.7038C22.0698 12.7455 22.1499 12.8246 22.2377 12.9409C22.2487 12.9563 22.2641 12.9782 22.2838 13.0068C22.5055 13.3141 22.7284 13.4677 22.9523 13.4677C23.1147 13.4677 23.2519 13.4096 23.3639 13.2932C23.4758 13.1747 23.5318 13.0276 23.5318 12.852C23.5318 12.6852 23.4835 12.56 23.3869 12.4766C23.2903 12.3932 23.107 12.3295 22.837 12.2856C22.668 12.2593 22.5494 12.2099 22.4814 12.1375C22.4133 12.0628 22.3793 11.9509 22.3793 11.8016C22.3793 11.6633 22.4122 11.559 22.4781 11.4888C22.5462 11.4163 22.6658 11.3604 22.837 11.3208C23.006 11.2813 23.1312 11.2221 23.2124 11.143C23.2958 11.0618 23.3375 10.9575 23.3375 10.8302C23.3375 10.7051 23.3024 10.6052 23.2321 10.5306C23.1619 10.4559 23.0664 10.4186 22.9457 10.4186C22.8052 10.4186 22.6427 10.5031 22.4583 10.6722L22.4452 10.682C22.432 10.6952 22.409 10.7172 22.376 10.7479C22.1872 10.9279 22.0171 11.0179 21.8656 11.0179C21.7427 11.0179 21.6362 10.974 21.5462 10.8862C21.4584 10.7962 21.4145 10.6875 21.4145 10.5602C21.4145 10.277 21.5726 10.0158 21.8887 9.77652C22.2048 9.53505 22.5637 9.41432 22.9654 9.41432C23.3759 9.41432 23.7173 9.54054 23.9895 9.79299C24.2639 10.0432 24.4011 10.3528 24.4011 10.7216C24.4011 10.9235 24.3572 11.1046 24.2694 11.2649C24.1816 11.4229 24.0433 11.57 23.8545 11.7061Z",
    fill: "#FFE228"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9975 12.698C25.3865 12.9004 25.6743 13.147 25.8608 13.438C26.0506 13.7289 26.1454 14.072 26.1454 14.4673C26.1454 15.1029 25.9114 15.6341 25.4434 16.061C24.9754 16.4879 24.3872 16.7014 23.6789 16.7014C23.3943 16.7014 23.1207 16.6555 22.8583 16.5638C22.599 16.4753 22.3539 16.3425 22.1231 16.1654C21.8543 15.9599 21.6424 15.7338 21.4874 15.4871C21.3357 15.2404 21.2598 15.008 21.2598 14.7898C21.2598 14.5685 21.3262 14.3882 21.459 14.2491C21.5918 14.1099 21.7626 14.0404 21.9713 14.0404C22.1041 14.0404 22.2211 14.072 22.3223 14.1352C22.4266 14.1953 22.5421 14.3092 22.6685 14.4768C22.6844 14.4989 22.7065 14.5305 22.735 14.5716C23.0543 15.0143 23.3753 15.2357 23.6979 15.2357C23.9319 15.2357 24.1295 15.1519 24.2908 14.9843C24.452 14.8135 24.5327 14.6017 24.5327 14.3487C24.5327 14.1084 24.4631 13.9281 24.324 13.8079C24.1848 13.6878 23.9208 13.5961 23.5318 13.5328C23.2883 13.4949 23.1176 13.4237 23.0196 13.3194C22.9215 13.2119 22.8725 13.0506 22.8725 12.8356C22.8725 12.6363 22.9199 12.4861 23.0148 12.3849C23.1128 12.2806 23.2852 12.1999 23.5318 12.143C23.7753 12.0861 23.9556 12.0007 24.0726 11.8869C24.1927 11.7699 24.2528 11.6197 24.2528 11.4363C24.2528 11.256 24.2022 11.1121 24.101 11.0046C23.9998 10.8971 23.8623 10.8433 23.6884 10.8433C23.486 10.8433 23.252 10.9651 22.9863 11.2086L22.9674 11.2228C22.9484 11.2418 22.9152 11.2734 22.8678 11.3177C22.5958 11.577 22.3507 11.7066 22.1325 11.7066C21.9555 11.7066 21.8021 11.6434 21.6724 11.5169C21.5459 11.3873 21.4827 11.2307 21.4827 11.0473C21.4827 10.6394 21.7104 10.2631 22.1657 9.91839C22.6211 9.57055 23.1381 9.39662 23.7168 9.39662C24.3082 9.39662 24.7999 9.57845 25.192 9.94211C25.5873 10.3026 25.7849 10.7485 25.7849 11.2797C25.7849 11.5707 25.7217 11.8315 25.5952 12.0624C25.4687 12.2901 25.2695 12.5019 24.9975 12.698Z",
    fill: "#FFA400"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8193 13.6957C17.8193 13.6957 19.0233 9.01648 23.3709 9.01648C27.4877 9.01648 28.4827 12.643 28.4827 12.643C28.4827 12.643 27.7545 8.23782 23.0681 8.36039C18.3745 8.48296 17.8193 13.191 17.8193 13.6957Z",
    fill: "#BE2F55"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6055 16.7814C18.6055 16.7814 20.1845 19.5788 23.5442 19.4274C26.904 19.276 28.2018 15.9379 28.2018 15.9379C28.2018 15.9379 26.63 19.9465 23.3712 19.9538C20.1123 19.961 18.6055 16.7814 18.6055 16.7814Z",
    fill: "url(#paint10_linear_2390_49759)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2390_49759",
    x1: 29.8744,
    y1: 12.9169,
    x2: 44.0273,
    y2: 12.9169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2390_49759",
    x1: 15.8447,
    y1: -112.138,
    x2: 1.69178,
    y2: -112.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2390_49759",
    x1: 37.5597,
    y1: 22.0157,
    x2: 37.5597,
    y2: 5.23117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2390_49759",
    x1: 8.12266,
    y1: 22.0086,
    x2: 8.12266,
    y2: 5.23128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2390_49759",
    x1: 1.74902,
    y1: 5.69268,
    x2: 11.0064,
    y2: 5.69268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2390_49759",
    x1: 35.0957,
    y1: 5.32496,
    x2: 43.5312,
    y2: 5.32496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2390_49759",
    x1: 10.6029,
    y1: 19.4131,
    x2: 35.9311,
    y2: 19.4131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2390_49759",
    x1: 10.5368,
    y1: 3.55858,
    x2: 35.9298,
    y2: 3.55858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2390_49759",
    x1: 15.5197,
    y1: 3.61841,
    x2: 34.5477,
    y2: 3.00048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2390_49759",
    x1: 23.2058,
    y1: 19.8686,
    x2: 23.2058,
    y2: 8.75276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EF6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2390_49759",
    x1: 18.6055,
    y1: 17.9494,
    x2: 28.209,
    y2: 17.9494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinWinnerTrophy3);
export default __webpack_public_path__ + "static/media/spin-winner-trophy3.a60d29204c3bcd3373427c279f2313b7.svg";
export { ForwardRef as ReactComponent };